import React from 'react';
import Autosuggest from 'react-autosuggest';
import LoadingSpinner from './LoadingSpinner';

export default class AutocompleteInput extends React.Component {
    constructor(props) {
        super(props);

        const value = (this.props.value && !this.props.multi)
            ? (this.props.options[this.props.options.map(o => o.key).indexOf(this.props.value)] || {}).value || (this.props.overridable && this.props.value) || ''
            : '';
            
        this.state = {
            value: value,
            searchValue: '',
            suggestions: []
        };
    }

    //In order to allow this input to get cleared out by external change... would need some more development.  Implement only if becomes necessary.
    // componentWillReceiveProps(nextProps) {
    //     if(!nextProps.multi && this.state.value && !nextProps.value) {
    //         this.setState({ value: '' });
    //     }
    // }

    onChange(event, { newValue }) {
        if (this.props.overridable) { //non-multi, allow override to custom input.
            this.setState({ value: newValue }, () => this.props.update(this.props.name, newValue));
        } else {
            this.setState({
                value: '',
                searchValue: newValue
            });
            if ((!newValue || this.state.value) && !this.props.multi) {
                this.props.update(this.props.name, '');
            }
        }
    }

    onSuggest(suggestion) {
        this.setState({
            suggestions: this.props.options
                .filter(o => o.value.toLowerCase().indexOf(suggestion.value.toLowerCase()) >= 0
                    && (this.props.multi ? this.props.selection.indexOf(o.key) < 0 : true))
                .sort((o1, o2) => o1.value.toLowerCase().indexOf(suggestion.value.toLowerCase()) - o2.value.toLowerCase().indexOf(suggestion.value.toLowerCase()))
        });
    }

    onSelectSuggestion(event, { suggestion }) {
        this.setState({
            value: this.props.multi ? '' : suggestion.value,
            searchValue: ''
        });
        this.props.update(this.props.name, this.props.multi ? [...this.props.selection, suggestion.key] : suggestion.key);
    }

    clearSuggestions() {
        this.setState({
            suggestions: []
        });
    }

    render() {
        return (
            <div>
                {this.props.title && <label className="input-label">{this.props.title}</label>}
                <div className={`search-input ${this.props.className}`} >
                    {!this.props.overridable && <i className="material-icons">search</i>}
                    <Autosuggest
                        suggestions={this.state.suggestions}
                        onSuggestionsFetchRequested={this.onSuggest.bind(this)}
                        onSuggestionsClearRequested={this.clearSuggestions.bind(this)}
                        getSuggestionValue={s => s.value}
                        onSuggestionSelected={this.onSelectSuggestion.bind(this)}
                        renderSuggestion={s => <span key={s.key}>{s.displayValue || s.value}</span>}
                        shouldRenderSuggestions={val => this.props.showList ? true : val && val.trim().length}
                        focusInputOnSuggestionClick={!this.props.showList}
                        inputProps={{
                            tabIndex: this.props.tabIndex || '',
                            disabled: this.props.disabled,
                            placeholder: this.props.placeholder,
                            className: this.props.className,
                            value: this.state.searchValue || this.state.value,
                            onChange: this.onChange.bind(this)
                        }}
                    />
                    {this.props.loading && <LoadingSpinner height="12" />}
                    {(!this.state.value && this.state.searchValue && !this.state.suggestions.length) && <span className="error-label">No suggestions</span>}
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/commonComponents/util/AutocompleteInput.jsx